import React from 'react';
import { withRouter, Link, BrowserRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactPaginate from 'react-paginate';

import { boardsActions } from '../../../store/boards';
import kara from '../../../assets/front/img/header/kara.jpg';

class Blog extends React.Component {

    constructor(props) {
        super(props);
        this.category = this.props.location.pathname.split('/')[1];
        this.subCategory = this.props.location.pathname.split('/')[2];

        //const navigateTo = useNavigate();

        // url에  페이지가 있으면 
        const params = new URLSearchParams(this.props.location.search);
        var page = Number(params.get('p') === undefined ? 0 : params.get('p'));
        page = page === 0 ? 0 : page - 1;
        //console.log(page); // page
        this.state = { selectedPage: page };
    }

    componentDidMount() {
        this.props.getDictionary(this.category, this.subCategory);

        var self = this;
        window.addEventListener('popstate', function (event) {
            //console.log(`${JSON.stringify(event.state)} | ${event.state} | ${window.location.origin} | ${window.location.pathname}`);
            //console.log(event.state.p);

            if (event.state !== undefined && event.state.p !== undefined) {
                var href = window.location.pathname + '?p=' + event.state.p;
                //self.setState({ selectedPage: event.state.p });
                window.location.href = href;
                //window.history.push(href);
                //window.location.reload();
                //window.location.assign(href);
                //window.history.back();
                //console.log(self.props);
                //self.onPageChange({ selected: event.state.p, fource: true })
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        console.log(prevState.selectedPage + " : " + this.state.selectedPage)
        if (prevState.selectedPage !== this.state.selectedPage) {
            prevState.selectedPage = this.state.selectedPage;
            this.props.getDictionary(this.category, this.subCategory, this.state.selectedPage + 1);
        }
    }

    onPageChange = data => {
        this.setState({ selectedPage: data.selected });

        var pathname = window.location.pathname + '?p=' + (data.selected + 1);
        var state = { p: data.selected + 1 };
        //this.props.history.push(window.location.pathname, state);
        window.history.pushState(state, null, pathname);
    };

    fileFilter(board) {
        const files = board.files.filter(file => file.type === "thumbnails");
        if (files.length !== 0) return files[0].name;
        return null;
    }

    render() {
        if (!this.props.boards.boards && this.props.boards.length === 0) return null;

        document.querySelector("main").scrollIntoView();

        return (
            <div className="col-lg-9">
                <div className="g-pr-15--lg">
                    {this.props.boards.boards.map((board, index) => (
                        <div key={board.boardId} >
                            <article className="row align-items-center u-block-hover">
                                <div className="col-md-5 g-mb-10">
                                    <div className="g-overflow-hidden">
                                        {this.fileFilter(board) && <img src={`/api/files/thumbnails/${this.fileFilter(board)}`} className="img-fluid u-block-hover__main--zoom-v1 g-mb-minus-6" alt="kara" />}
                                        {!this.fileFilter(board) && <img src={kara} className="img-fluid u-block-hover__main--zoom-v1 g-mb-minus-6" alt="kara" />}
                                    </div>
                                </div>
                                <div className="col-md-7 g-mb-10">
                                    <div className="g-pa-10--md">
                                        <ul className="list-inline g-color-gray-dark-v4 g-font-weight-500 g-font-size-12">
                                            <li className="list-inline-item mx-1">카라</li>
                                            <li className="list-inline-item mx-1">&#183;</li>
                                            <li className="list-inline-item mx-1 g-font-weight-300">{moment(board.time).format("YYYY-MM-DD")}</li>
                                            <li className="list-inline-item mx-1">&#183;</li>
                                            <li className="list-inline-item mx-1 g-font-weight-300"><i className="icon-mouse g-font-size-11"></i>{board.hit}</li>
                                        </ul>
                                        <h2 className="h4 g-color-black g-font-weight-600 mb-4">
                                            <Link to={`/details/${this.category}/${this.subCategory}/${board.boardId}`} className="u-link-v5 g-color-black g-color-primary--hover">{board.title}</Link>
                                        </h2>
                                        <Link to={`/details/${this.category}/${this.subCategory}/${board.boardId}`}
                                            className="g-color-gray-dark-v4 g-color-primary--hover g-font-weight-300 g-font-size-12 g-text-underline--none--hover text-uppercase">
                                            {board.summary ? board.summary.substring(0, 160) : ''}
                                            {board.summary ? (board.summary.length > 160 ? <span> ...</span> : '') : ''}
                                        </Link>
                                    </div>
                                </div>
                            </article>
                            <hr className="g-mb-50 g-mx-15" />
                        </div>
                    ))}
                </div>

                {this.props.boards.pageCount !== 0 &&
                    <ReactPaginate
                        initialPage={this.state.selectedPage}
                        previousLabel={'이전'}
                        nextLabel={'다음'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={this.props.boards.pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.onPageChange}
                        containerClassName={'pagination justify-content-center'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        //hrefBuilder={(index) => {
                        //    return <Link to={`${this.category}/${this.subCategory}/${index}`}></Link>;
                        //}}
                    />
                }

            </div>
        )
    }
}

export default connect(
    state => state.boards,
    dispatch => bindActionCreators({ ...boardsActions }, dispatch)
)(withRouter(Blog));



// WEBPACK FOOTER //
// ./src/pages/front/board/blog.js